// extracted by mini-css-extract-plugin
export default {"search":"Search_search__SSARX","disabled":"Search_disabled__tLQD1"};